import { Link } from 'react-router-dom';

export function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-md p-6 mb-8">
        <h1 className="text-2xl font-bold text-[#2563eb] mb-6">Integritetspolicy</h1>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">1. Introduktion</h2>
          <p className="mb-2">
            SOKASTIFTELSEMEDEL.SE är mån om din personliga integritet. Denna integritetspolicy förklarar hur vi samlar in, 
            använder, delar och skyddar information i samband med våra tjänster.
          </p>
          <p>
            Genom att använda vår plattform godkänner du denna integritetspolicy och vår insamling och hantering av personuppgifter 
            enligt beskrivningen nedan.
          </p>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">2. Information vi samlar in</h2>
          <p className="mb-2"><strong>2.1 Information du tillhandahåller</strong></p>
          <ul className="list-disc pl-6 mb-4">
            <li>E-postadress (när du väljer att få information om sparade stiftelser)</li>
            <li>Sökfrågor och parametrar du använder på plattformen</li>
            <li>Information du frivilligt delar med oss via formulär eller kommunikation</li>
          </ul>
          
          <p className="mb-2"><strong>2.2 Information vi samlar in automatiskt</strong></p>
          <ul className="list-disc pl-6">
            <li>Enhetsspecifik information (webbläsartyp, IP-adress, etc.)</li>
            <li>Användningsdata och besöksmönster</li>
            <li>Cookies och liknande teknologier</li>
          </ul>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">3. Hur vi använder informationen</h2>
          <p className="mb-2">Vi använder insamlad information för att:</p>
          <ul className="list-disc pl-6">
            <li>Tillhandahålla, underhålla och förbättra våra tjänster</li>
            <li>Skicka e-post om sparade stiftelser när du begär det</li>
            <li>Förstå hur användare interagerar med plattformen</li>
            <li>Förbättra användarupplevelsen och anpassa innehåll</li>
            <li>Förhindra missbruk och upprätthålla säkerhet</li>
            <li>Uppfylla rättsliga skyldigheter</li>
          </ul>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">4. Datalagring</h2>
          <p className="mb-2">
            Vi lagrar bara dina personuppgifter så länge det är nödvändigt för de ändamål som anges i denna policy, 
            eller för att uppfylla rättsliga skyldigheter.
          </p>
          <p>
            Sparade stiftelser och e-postadresser lagras endast under den aktiva sessionen eller för den tid som krävs 
            för att leverera tjänsten du begärt.
          </p>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">5. Delning av information</h2>
          <p className="mb-2">Vi delar inte dina personuppgifter med tredje part förutom i följande fall:</p>
          <ul className="list-disc pl-6">
            <li>När det krävs enligt lag</li>
            <li>Med betrodda tjänsteleverantörer som hjälper oss att driva vår plattform</li>
            <li>Om verksamheten genomgår en fusion, försäljning eller annan strukturförändring</li>
          </ul>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">6. Säkerhet</h2>
          <p>
            Vi använder rimliga säkerhetsåtgärder för att skydda dina personuppgifter från obehörig åtkomst, 
            användning eller avslöjande. Dock kan ingen metod för överföring över internet eller elektronisk 
            lagring garanteras vara 100% säker.
          </p>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">7. Dina rättigheter</h2>
          <p className="mb-2">Enligt GDPR har du rätt att:</p>
          <ul className="list-disc pl-6">
            <li>Få åtkomst till dina personuppgifter</li>
            <li>Rätta felaktiga uppgifter</li>
            <li>Begära radering av dina uppgifter</li>
            <li>Invända mot behandling av dina uppgifter</li>
            <li>Begära begränsning av behandling</li>
            <li>Dataportabilitet</li>
          </ul>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">8. Cookies</h2>
          <p className="mb-2">
            Vi använder cookies för att förbättra din upplevelse, förstå användarmönster och tillhandahålla personliga funktioner. 
            Du kan kontrollera eller radera cookies via din webbläsarinställningar.
          </p>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">9. Ändringar av denna policy</h2>
          <p>
            Vi kan uppdatera denna integritetspolicy från tid till annan. Vi meddelar om väsentliga ändringar genom 
            att publicera den nya policyn på denna sida och uppdatera "senast uppdaterad"-datumet.
          </p>
        </section>
        
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-3">10. Kontakta oss</h2>
          <p>
            Om du har frågor eller funderingar kring denna integritetspolicy, vänligen kontakta oss på: 
            <a href="mailto:info@heimlandr.com" className="text-[#2563eb] hover:underline ml-1">
              info@heimlandr.com
            </a>
          </p>
        </section>
        
        <div className="mt-8 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600">Senast uppdaterad: 17 mars 2025</p>
          <div className="mt-4">
            <Link to="/" className="text-[#2563eb] hover:underline">
              &larr; Tillbaka till startsidan
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
